<script setup lang="ts">
import { TrashCanIcon } from '@fond-of/satch-icons'
</script>

<template>
  <button class="absolute z-10 size-5 cursor-pointer md:size-7">
    <TrashCanIcon />
  </button>
</template>
